import React, { useEffect } from "react";
import InputAHSF from "../../Components/InputAHSF";
import { useDispatch, useSelector } from "react-redux";
import { GetListReportsStagesByAP_ApplicationInformationGUIDTotalTime } from "../../Redux/Reducers/ReportStage/Stages";

const StageInformation = (props) => {
  const dispatch = useDispatch(); // Used to dispatch Redux actions.
 

  const state = useSelector((state) => {
    return {
      loadingReportsStagesById:
        state.TypeOfJobOpportunityDropDown.loadingReportsStagesById,
      ReportsStagesById: state.Stages.ReportsStagesById,
      CurrentStageInfo: state.Stages.CurrentStageInfo,
    };
  });
  console.log(state.ReportsStagesById, "jgfgfdsa");
  const getData = async () => {
    const data = await dispatch(
      GetListReportsStagesByAP_ApplicationInformationGUIDTotalTime({
        reportsStagesGuid: props.pR_ReportsStagesGuid,
        applicationInformationGUID:
          localStorage.getItem("aI_ApplicationInformationId") ||
          localStorage.getItem("aI_ApplicationInformationId_Manager"),
      })
    );
  };
  useEffect(() => {
    getData();
  }, []);
  console.log(state.CurrentStageInfo,"CurrentStageInfo");
  
  return (
    <>
      <div className="InformationAboutApplicationContainer">
        <div className="hildIinf">
          <div className="childInformationAboutApplicationContainer">
            <InputAHSF
              fieldsName="stagesName"
              show={true}
              disabled={true}
              value={state.ReportsStagesById?.stagesName}
            />
            <InputAHSF
              fieldsName="timeStage"
              show={true}
              disabled={true}
              value={state.CurrentStageInfo?.ActualDuration}
            />
            <InputAHSF
              fieldsName="stagesTimeEnd"
              show={true}
              disabled={true}
              value={state.CurrentStageInfo?.RemainingDuration}
            />
            <InputAHSF
              fieldsName="statrMonth"
              show={true}
              disabled={true}
              value={state.ReportsStagesById?.startMonth}
            />
            <InputAHSF
              fieldsName="endMonth"
              show={true}
              disabled={true}
              value={state.ReportsStagesById?.endMonth}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default StageInformation;
